import { Slide, Snackbar } from '@mui/material';
import { observer } from 'mobx-react';
import { generalStore } from 'src/stores/GeneralStore';
import { Colors } from '../utils/Theme';

const SlideTransition = (props: any) => <Slide {...props} direction="up" />;

const TOAST_DURATION = 5000;

export const Toast = observer(() => {
  const handleClose = () => {
    generalStore.unsetInfoMsg();
    generalStore.unsetError();
  };

  return (
    <>
      <Snackbar
        data-cy="error-toast"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={!!generalStore.error}
        key={generalStore.error?.message}
        onClose={handleClose}
        autoHideDuration={TOAST_DURATION}
        message={generalStore.error?.message}
        TransitionComponent={SlideTransition}
        ContentProps={{
          style: {
            backgroundColor: Colors.SECONDARY_COLOR,
            color: 'white',
          },
        }}
      />
      <Snackbar
        data-cy="info-toast"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={!!generalStore.infoMsg}
        key={generalStore.infoMsg}
        onClose={handleClose}
        autoHideDuration={TOAST_DURATION}
        message={generalStore.infoMsg}
        TransitionComponent={SlideTransition}
      />
    </>
  );
});
